import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';

class Accordion {
    constructor(elem) {
        this.elem = elem;
        this.toggles = this.elem.getElementsByClassName('accordion__toggle');
        this.content = this.elem.querySelector('.accordion__collapse');
        this.boundToggleListener = Accordion.toggleAccordionItem.bind(this);
    }

    init() {
        for (const toggle of this.toggles) {
            AccessibilityHelper.addAndHandleLabelsToggle('collapsible', toggle, this.content, toggle.checked, 'button');
            toggle.addEventListener('change', this.boundToggleListener);
            this.handleResize();
        }
    }

    /**
     * check if accordion is open by checking the trigger state
     * @param accordionToggle
     * @returns {*}
     */
    static isOpen(accordionToggle) {
        return accordionToggle.checked;
    }

    static openItem(item) {
        item.classList.add('active');
        const toggle = item.querySelector('.accordion__toggle');

        const itemContent = item.querySelector('.accordion__collapse');
        const maxHeight = itemContent.scrollHeight;

        toggle.setAttribute('checked', 'checked');
        itemContent.style.maxHeight = `${maxHeight}px`;
        Accordion.setMenuMaxHeight(toggle, maxHeight);
    }

    static closeItem(item) {
        const toggle = item.querySelector('.accordion__toggle');
        const itemContent = item.querySelector('.accordion__collapse');

        if (toggle) {
            toggle.checked = false;
        }

        if (itemContent) {
            itemContent.style.maxHeight = 0;
        }
    }

    static setMenuMaxHeight(element, childMaxHeight = 0) {
        const elementContent = element.parentNode.querySelector('.accordion__collapse');

        if (elementContent && !elementContent.isSameNode(element)) {
            const maxHeight = elementContent.scrollHeight + childMaxHeight;
            elementContent.style.maxHeight = `${maxHeight}px`;
        }
    }

    static toggleAccordionItem(event) {
        const toggleInput = event.currentTarget;
        const accordionItem = toggleInput.closest('.accordion__item');

        if (Accordion.isOpen(toggleInput)) {
            Accordion.openItem(accordionItem);
            Accordion.closeOthersOnOpen(toggleInput);

            return;
        }

        Accordion.closeItem(accordionItem);
    }

    /**
     * close other accordions if a new one is triggered
     */
    static closeOthersOnOpen(toggleInput) {
        if (Accordion.isOpen(toggleInput)) {
            const accordionItem = toggleInput.closest('.accordion__item');
            const siblings = accordionItem.parentNode.children;

            for (const sibling of siblings) {
                if (sibling !== accordionItem) {
                    Accordion.closeItem(sibling);
                }
            }

            const children = accordionItem.querySelectorAll('.accordion__content .accordion__item--has-children');
            if (children.length) {
                for (const child of children) {
                    Accordion.closeItem(child);
                }
            }
        }
    }

    /**
     * add resize handling (recalculate item heights and handle breakpoint crossing)
     */
    handleResize() {
        window.addEventListener('resize', GeneralHelper.throttle(() => {
            const activeElements = this.elem.querySelectorAll('.accordion__toggle:checked');

            for (const item of activeElements) {
                Accordion.setMenuMaxHeight(item);
            }
        }, 200));
    }
}

export default Accordion;
